/**
 * Admin-facing note on the tutor-feedback v2 surfaces.
 *
 * The gate is per-student, and the admin view can't resolve another user's
 * gate state — so this states the condition rather than asserting the content
 * is hidden. It said "Not shown to students", which became plainly wrong once
 * the gate was switched on.
 */
interface Props {
    gate: string;
}

export function GatedNote({ gate }: Props) {
    return (
        <p className="sol-gated-note" role="note">
            Shown to students only when <code>{gate}</code> is enabled for them
        </p>
    );
}
